import React from 'react';
import PropTypes from 'prop-types';
import PieChart from '../../../../core/chart/PieChart';
import Card from '../../../../core/layout/Card';
import Async from '../../../../core/layout/Async';

export default function PlacementTestsPerLevelChart(props) {
  const total = props.data.map((level) => level.total).reduce((acc, level) => acc + level, 0);
  return (
    <Card title="Placement Tests per Level">
      <Async fetching={props.isFetching}>
        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <PieChart
            data={props.data.map((level) => level.total)}
            labels={props.data.map((level) => level.course)}
            colors={[
              '#251657',
              '#43397F',
              '#615EA8',
              '#8186D3',
              '#A2B0FF',
              '#A07FC7',
              '#00C7DB',
              '#009AC8',
              '#006DAC',
              '#174185',
            ]}
            options={{
              tooltips: {
                callbacks: {
                  label: (tooltipItem, data) => {
                    const value = data.datasets[0].data[tooltipItem.index];
                    return `${data.labels[tooltipItem.index]}: ${value} (${((value / total) * 100).toFixed(1)}%)`;
                  },
                },
              },
            }}
          />
        </div>
      </Async>
    </Card>
  );
}

PlacementTestsPerLevelChart.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
};

PlacementTestsPerLevelChart.defaultProps = {
  isFetching: false,
};
